import cookie from 'js-cookie';

import {setPreferredInstitute, setPreferredInstituteNumber} from 'app/components/instituteSelection/instituteCookies';
import {getCookieNameForHash} from 'app/components/instituteSelection/utils';
import {Undef} from 'app/interface';
import {GemSettings} from 'app/utils/config/interface';
import {isModalPath, MODAL_LINK_PREFIX} from 'app/utils/location/isModalPath';
import {redirectToPage} from 'app/utils/location/redirectToPage';
import {replacePlaceholders} from 'app/utils/replacePlaceholder/replacePlaceholders';

export function redirect(instituteNumber: string, instituteUrl: string, cId?: string): void {
    setPreferredInstitute(instituteUrl);
    setPreferredInstituteNumber(instituteNumber);

    if (cId && window.location.href.indexOf('at/sgruppe') !== -1) {
        // refresh
        setTemporaryHashIntoCookie(cId);
        reload();
    } else {
        const parts = window.location.pathname.split('/');

        parts[1] = instituteUrl; // replace institute

        redirectToPage(`${window.location.protocol}//${window.location.host}${parts.join('/')}${checkLocationHash() ? window.location.hash : ''}`);
    }
}

export function setPreferredInstituteNumberAndReload(instituteUrl: string, instituteNumber: string): void {
    setPreferredInstitute(instituteUrl);
    setPreferredInstituteNumber(instituteNumber);
    reload();
}

export function reload(): void {
    if (checkLocationHash()) {
        window.location.reload();
    } else {
        // remove modalComponent hash part  when we are in a modal which is based on hash
        const currentUrl = new URL(window.location.href);
        let hashBeforeModal = currentUrl.hash.split(MODAL_LINK_PREFIX)[0];
        if (hashBeforeModal.endsWith('#')) {
            hashBeforeModal = hashBeforeModal.replace('#', '');
        }
        currentUrl.hash = hashBeforeModal || '';
        const newHref = currentUrl.toString();
        if (newHref === window.location.href) {
            window.location.reload();
        } else {
            redirectToPage(newHref);
        }
    }
}

export function setTemporaryHashIntoCookie(cId: string): void {
    if (checkLocationHash()) {
        cookie.set(getCookieNameForHash(cId), window.location.hash, {expires: new Date(new Date().getTime() + 1000 * 60)});
    }
}

export function checkLocationHash(): boolean {
    return !isModalPath(window.location.hash);
}

export function updateHashFromCookie(cId: string): void {
    const hashFromCookie = cookie.get(getCookieNameForHash(cId));
    if (hashFromCookie) {
        cookie.remove(getCookieNameForHash(cId));
        window.location.hash = hashFromCookie;
    }
}

export function redirectToLink(
    instituteNumber: string,
    linkTarget: Undef<string>,
    linkUrl: string,
    gemSettings: GemSettings,
    additionalValues?: Record<string, unknown>,
): void {
    const separator = linkUrl.indexOf('?') === -1 ? '?' : '&';
    const parts = window.location.hash.split('?');
    let parameters = '';

    if (parts.length > 1) {
        parameters = `${separator}${parts[1]}`;
    }

    const href = replacePlaceholders({gemSettings, template: `${linkUrl}${parameters}`, additionalValues: {...additionalValues, instituteNumber}});

    const hrefElement = document.createElement('a');
    hrefElement.setAttribute('href', href);

    if (linkTarget === 'NEW_TAB') {
        hrefElement.setAttribute('target', '_blank');
    }

    document.body.appendChild(hrefElement);

    hrefElement.click();
}
